import React, { useState, useEffect, useRef } from 'react';
import './passengerSocialProfile.css';
import { 
  FaImage, FaVideo, FaVideoSlash, FaSmile, 
  FaHeart, FaComment, FaShare, FaPlay, FaHome, FaUser, FaTimes, FaArrowLeft,
  FaPhone, FaWhatsapp, FaMapMarkerAlt, FaClock, FaCalendarAlt, FaMoneyBillWave,
  FaMapPin, FaChartBar, FaHistory, FaWallet
} from 'react-icons/fa';
import { IoMdChatbubbles } from "react-icons/io";
import { MdExplore } from "react-icons/md";
import { BsFillPlayCircleFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
// Firebase Imports
import { ref, onValue, push, set, remove, get } from 'firebase/database';
import { getStorage, ref as sRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, auth } from '../firebase'; 
import { formatCurrency } from "../utils/formatCurrency";

const emojis = ['😀', '😂', '😍', '🙏', '🔥', '🌴', '🚕', '🛣️', '💯', '✨'];

const DriverProfileOverlay = ({ driver, onClose }) => {
  const { t } = useTranslation();  
  const profilePic = driver?.photoURL || "/default-avatar.png";
const userName = driver?.name || t("driver");  
const currentUser = auth.currentUser || null;
const viewedUid = driver?.uid || currentUser?.uid || null;
  // --- STATE ---
  const [posts, setPosts] = useState([]);
  const [reels, setReels] = useState([]);
  const [myRides, setMyRides] = useState([]); 
  const [selectedRide, setSelectedRide] = useState(null); 
  const [postText, setPostText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [mediaType, setMediaType] = useState(null); 
  const [uploading, setUploading] = useState(false);
  const [showMoods, setShowMoods] = useState(false);
  const [replyInputs, setReplyInputs] = useState({});
  const [activeView, setActiveView] = useState('feed'); 
  const [postFilter, setPostFilter] = useState('all'); 
  const [showTransactions, setShowTransactions] = useState(false);
  const fabInputRef = useRef(null); 
  const [isOnline, setIsOnline] = useState(false);
const userCountry =
  driver?.country ||
  driver?.driverCountry ||
  localStorage.getItem("country") ||
  "United States";

  const [commentInputs, setCommentInputs] = useState({});
const [rideStatsView, setRideStatsView] = useState(null);
const isOwner = currentUser?.uid === viewedUid;
 // --- FETCH REALTIME DATA ---
useEffect(() => {
  if (!currentUser || !viewedUid) return;

  const postsRef = ref(db, 'social_posts');
  const reelsRef = ref(db, 'social_reels');
const ridesRef = ref(db, "rides");
const financeRef = ref(db, `financeHistory/${viewedUid}`);

  const unsubPosts = onValue(postsRef, (snap) => {
    if (snap.exists()) {
      const postsArray = Object.entries(snap.val())
        .map(([id, val]) => ({ id, ...val }))
.filter((post) => post.wallOwnerId === viewedUid)         // private like passenger
        .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

      setPosts(postsArray);
    } else {
      setPosts([]);
    }
  });

  const unsubReels = onValue(reelsRef, (snap) => {
    if (snap.exists()) {
      const reelsArray = Object.entries(snap.val())
        .map(([id, val]) => ({ id, ...val }))
.filter((reel) =>
  reel.userId === viewedUid ||
  reel.wallOwnerId === viewedUid
)

        .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

      setReels(reelsArray);
    } else {
      setReels([]);
    }
  });



  let ridesData = {};
let financeData = {};

const buildRides = async () => {
  const oldRides = Object.entries(ridesData)
    .map(([id, val]) => ({
      id,
      ...val,
    }))
    .filter((ride) => ride.driverId === viewedUid);

  const permanentRides = Object.entries(financeData)
    .map(([id, val]) => ({
      id,
      ...val,
    }));

  const merged = [...oldRides, ...permanentRides];

  const unique = Object.values(
    merged.reduce((acc, ride) => {
      acc[ride.rideId || ride.id] = ride;
      return acc;
    }, {})
  ).sort(
    (a, b) =>
      (b.completedAt || b.timestamp || 0) -
      (a.completedAt || a.timestamp || 0)
  );


  const passengerCache = {};
  const enrichedRides = await Promise.all(
    unique.map(async (ride) => {
      let photo =
        ride.passengerPhoto ||
        ride.passengerProfile?.photoUrl ||
        ride.passengerProfile?.photoURL;

   if (!photo && ride.passengerId) {

  // Check cache first
  if (!passengerCache[ride.passengerId]) {

    const pSnap = await get(
      ref(db, `passengers/${ride.passengerId}`)
    );

    passengerCache[ride.passengerId] =
      pSnap.exists()
        ? pSnap.val()
        : null;
  }

  // Use cached data
  const pData =
    passengerCache[ride.passengerId];

  if (pData) {
    photo =
      pData.photoUrl ||
      pData.photoURL;
  }
}

      return {
        ...ride,
        displayPhoto:
          photo || "/default-avatar.png",
      };
    })
  );

  setMyRides(enrichedRides);
};

const unsubRides = onValue(
  ridesRef,
  async (snap) => {
    ridesData = snap.val() || {};
    await buildRides();
  }
);

const unsubFinance = onValue(
  financeRef,
  async (snap) => {
    financeData = snap.val() || {};
    await buildRides();
  }
);



  return () => {
  unsubPosts();
  unsubReels();
  unsubRides();
  unsubFinance();
};
}, [currentUser, viewedUid]);

  // --- HANDLERS ---
const handleFileSelect = async (e) => {

  const file = e.target.files[0];

  if (!file) return;

// LIMITS
const MAX_VIDEO_SIZE = 50 * 1024 * 1024; // 50MB
const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB

const isVideo =
  file.type.startsWith("video");

const isImage =
  file.type.startsWith("image");

// BLOCK INVALID FILES
if (!isVideo && !isImage) {

  alert(
    "Only images and videos are allowed"
  );

  return;
}

// ALLOWED VIDEO TYPES
const allowedVideoTypes = [
  "video/mp4",
  "video/webm",
  "video/quicktime"
];

// BLOCK UNSUPPORTED VIDEOS
if (
  isVideo &&
  !allowedVideoTypes.includes(file.type)
) {

  alert(
    "Unsupported video format"
  );

  return;
}


  // IMAGE LIMIT
  if (
    isImage &&
    file.size > MAX_IMAGE_SIZE
  ) {

    alert(
      "Image must be under 10MB"
    );

    return;
  }

  // VIDEO LIMIT
  if (
    isVideo &&
    file.size > MAX_VIDEO_SIZE
  ) {

    alert(
      "Video must be under 50MB"
    );

    return;
  }

  // VIDEO DURATION CHECK
  if (isVideo) {

    const video =
      document.createElement("video");

    video.preload = "metadata";

    video.onloadedmetadata = async () => {

      window.URL.revokeObjectURL(
        video.src
      );

      // MAX 60 SEC
      if (video.duration > 60) {

        alert(
          "Reel videos must be under 60 seconds"
        );

        return;
      }

      // ACCEPT VIDEO
      setSelectedFile(file);
      setMediaType("video");

      if (activeView === "reels") {
        await handleUploadReel(file);
      }
    };

    video.src =
      URL.createObjectURL(file);

    return;
  }

  // IMAGE ACCEPT
  setSelectedFile(file);
  setMediaType("image");

  if (activeView === "reels") {
    await handleUploadReel(file);
  }
};


useEffect(() => {

  const handleOffline = async () => {
    if (!viewedUid) return;

    await remove(
      ref(db, `onlineDrivers/${viewedUid}`)
    );
  };

  window.addEventListener(
    "beforeunload",
    handleOffline
  );

  return () => {
    window.removeEventListener(
      "beforeunload",
      handleOffline
    );
  };

}, [viewedUid]);


useEffect(() => {

  if (!viewedUid) return;

  const onlineRef = ref(
    db,
    `onlineDrivers/${viewedUid}`
  );

  const unsub = onValue(
    onlineRef,
    (snap) => {

      setIsOnline(
        snap.exists()
      );

    }
  );

  return () => unsub();

}, [viewedUid]);





const handleUploadReel = async (file) => {
  if (!file || !currentUser) return;

  try {
    setUploading(true);

    const storage = getStorage();

    const reelStorageRef = sRef(
      storage,
      `social_reels/${currentUser.uid}/${Date.now()}_${file.name}`
    );

    // Upload file
    await uploadBytes(reelStorageRef, file);

    // Get URL
    const reelUrl = await getDownloadURL(reelStorageRef);

    // Save to Firebase database
    await set(push(ref(db, "social_reels")), {
      userId: currentUser.uid,

      userName:
        currentUser.displayName ||
        localStorage.getItem("name") ||
        "User",

      userPhoto:
        currentUser.photoURL ||
        localStorage.getItem("photoURL") ||
        "/default-avatar.png",

      mediaUrl: reelUrl,

      mediaType: file.type.startsWith("video")
        ? "video"
        : "image",

      timestamp: Date.now(),

      likes: {},
      comments: {},
      visibility: "public"
    });

    alert("Reel uploaded successfully");

    setSelectedFile(null);
setMediaType(null);

  } catch (err) {
    console.error(err);
    alert("Failed to upload reel");
  } finally {
    setUploading(false);
  }
};





const handleCreatePost = async () => {
  if (!postText.trim() && !selectedFile) return;
  if (!currentUser || !viewedUid) return;

  setUploading(true);

  try {
    let mediaUrl = null;

    if (selectedFile) {
      const storage = getStorage();
      const fileRef = sRef(
        storage,
        `social_media/${currentUser.uid}/${Date.now()}_${selectedFile.name}`
      );
      await uploadBytes(fileRef, selectedFile);
      mediaUrl = await getDownloadURL(fileRef);
    }

    await set(push(ref(db, "social_posts")), {
      wallOwnerId: viewedUid,
      wallOwnerRole: "driver",

      authorId: currentUser.uid,
     authorName:
  currentUser.displayName ||
  localStorage.getItem("name") ||
  "User",

authorPhoto:
  currentUser.photoURL ||
  localStorage.getItem("photoURL") ||
  "/default-avatar.png",

authorRole:
  localStorage.getItem("role") || "driver",

      text: postText.trim(),
      mediaUrl,
      mediaType,
      timestamp: Date.now(),
      likes: {},
    });

    setPostText("");
    setSelectedFile(null);
    setMediaType(null);
    setShowMoods(false);
  } catch (error) {
    alert(t("post_failed"));
  } finally {
    setUploading(false);
  }
};

const timeAgo = (timestamp) => {
  if (!timestamp) return t("now");

  const seconds = Math.floor((Date.now() - timestamp) / 1000);

  if (seconds < 60) {
    return t("now");
  }

  if (seconds < 3600) {
    return `${Math.floor(seconds / 60)} ${t("minutes_ago")}`;
  }

  if (seconds < 86400) {
    return `${Math.floor(seconds / 3600)} ${t("hours_ago")}`;
  }

  return `${Math.floor(seconds / 86400)} ${t("days_ago")}`;
};


const handleAddComment = async (postId) => {
  if (!currentUser) return;

  const text = (commentInputs[postId] || "").trim();
  if (!text) return;

  try {
    const commentRef = push(ref(db, `social_posts/${postId}/comments`));

    await set(commentRef, {
  userId: currentUser.uid,

  userName:
    currentUser.displayName ||
    localStorage.getItem("name") ||
    "User",

  userPhoto:
    currentUser.photoURL ||
    localStorage.getItem("photoURL") ||
    "/default-avatar.png",

  text,
  timestamp: Date.now(),

  role:
    localStorage.getItem("role") || "driver",
});

    setCommentInputs((prev) => ({
      ...prev,
      [postId]: "",
    }));
  } catch (err) {
    console.error(err);
  }
};



const handleReactToComment = async (postId, commentId, emoji) => {
  if (!currentUser) return;

  const reactionRef = ref(
    db,
    `social_posts/${postId}/comments/${commentId}/reactions/${currentUser.uid}`
  );

  try {
    const snap = await get(reactionRef);

    if (snap.exists() && snap.val()?.value === emoji) {
      await remove(reactionRef);
    } else {
      await set(reactionRef, {
        value: emoji,
        userId: currentUser.uid,
        userName: currentUser.displayName || localStorage.getItem("name") || "User",
role: localStorage.getItem("role") || "driver",
        reactedAt: Date.now(),
      });
    }
  } catch (err) {
    console.error("Comment reaction failed:", err);
  }
};



  // --- DASHBOARD MATH ---
  const now = Date.now();
  const oneDay = 24 * 60 * 60 * 1000;
  const dailyRev = myRides.filter(r => now - r.timestamp < oneDay).reduce((sum, r) => sum + (Number(r.fare) || 0), 0);
  const weeklyRev = myRides.filter(r => now - r.timestamp < 7 * oneDay).reduce((sum, r) => sum + (Number(r.fare) || 0), 0);
  const monthlyRev = myRides.filter(r => now - r.timestamp < 30 * oneDay).reduce((sum, r) => sum + (Number(r.fare) || 0), 0);
  const totalRev = myRides.reduce((sum, r) => sum + (Number(r.fare) || 0), 0);
  const maxRev = Math.max(dailyRev, weeklyRev, monthlyRev, 1); 

  const groupedRides = myRides.reduce((groups, ride) => {
    const dateStr = ride.date || new Date(ride.timestamp).toLocaleDateString();
    if (!groups[dateStr]) groups[dateStr] = [];
    groups[dateStr].push(ride);
    return groups;
  }, {});


const startOfWeek = new Date();
const currentDay = startOfWeek.getDay(); // Sunday=0
const diffToMonday = currentDay === 0 ? 6 : currentDay - 1;
startOfWeek.setDate(startOfWeek.getDate() - diffToMonday);
startOfWeek.setHours(0, 0, 0, 0);

const weekDays = [
  t("monday"),
  t("tuesday"),
  t("wednesday"),
  t("thursday"),
  t("friday"),
  t("saturday"),
  t("sunday"),
];

const weeklyFinance = weekDays.map((day, index) => {
  const dayStart = new Date(startOfWeek);
  dayStart.setDate(startOfWeek.getDate() + index);
  dayStart.setHours(0, 0, 0, 0);

  const dayEnd = new Date(dayStart);
  dayEnd.setHours(23, 59, 59, 999);

  const dayTotal = myRides
    .filter((ride) => {
      const rideTime = new Date(ride.timestamp || 0).getTime();
      return rideTime >= dayStart.getTime() && rideTime <= dayEnd.getTime();
    })
    .reduce((sum, ride) => sum + (Number(ride.fare) || 0), 0);

  return {
    day,
    total: dayTotal
  };
});

const currentMonth = new Date().getMonth();
const currentYear = new Date().getFullYear();

const financeWeeklyTotal = myRides
  .filter((ride) => {
    const rideTime = new Date(ride.timestamp || 0).getTime();
    return rideTime >= startOfWeek.getTime();
  })
  .reduce((sum, ride) => sum + (Number(ride.fare) || 0), 0);

const financeMonthlyTotal = myRides
  .filter((ride) => {
    const d = new Date(ride.timestamp || 0);
    return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
  })
  .reduce((sum, ride) => sum + (Number(ride.fare) || 0), 0);

const financeYearlyTotal = myRides
  .filter((ride) => {
    const d = new Date(ride.timestamp || 0);
    return d.getFullYear() === currentYear;
  })
  .reduce((sum, ride) => sum + (Number(ride.fare) || 0), 0);



const acceptedRidesCount = myRides.filter(
  (r) => r.status === 'accepted' || r.status === 'completed' || r.tripEnded === true
).length;

const completedRidesCount = myRides.filter(
  (r) => r.status === 'completed' || r.tripEnded === true
).length;

const historyYearlyTotal = myRides
  .filter((ride) => {
    const d = new Date(ride.timestamp || 0);
    return d.getFullYear() === currentYear;
  })
  .reduce((sum, ride) => sum + (Number(ride.fare) || 0), 0);

const passengerSummary = myRides.reduce((acc, ride) => {
  const name = ride.passengerName || "Unknown Passenger";
  if (!acc[name]) {
    acc[name] = {
      name,
      rides: 0,
      total: 0,
      phone: ride.passengerPhone || "",
    };
  }

  acc[name].rides += 1;
  acc[name].total += Number(ride.fare) || 0;

  if (!acc[name].phone && ride.passengerPhone) {
    acc[name].phone = ride.passengerPhone;
  }

  return acc;
}, {});

const passengerList = Object.values(passengerSummary).sort((a, b) => b.total - a.total);

const historyBarsMax = Math.max(
  ...weeklyFinance.map((d) => d.total),
  financeWeeklyTotal,
  financeMonthlyTotal,
  historyYearlyTotal,
  1
);



  return (
    <div className="social-profile-overlay" style={{ background: '#f0f2f5' }}>
      <input type="file" accept="image/*,video/*" ref={fabInputRef} style={{ display: 'none' }} onChange={handleFileSelect} />

      {/* ULTRA-COMPACT TOP NAVBAR */}
      <div className="social-top-nav" style={{ padding: '8px 10px', minHeight: '45px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FaArrowLeft size={16} onClick={onClose} style={{ cursor: "pointer" }} />
<div style={{ fontSize: '16px', fontWeight: 'bold' }}>
  🚀 {t("kinahub")}
</div>          
        </div>
       <div className="social-nav-links" style={{ gap: '8px' }}>
  <div
    onClick={() => {setActiveView('feed'); setPostFilter('all');}}
    style={{
      color: activeView === 'feed' ? '#ff416c' : 'white',
      fontSize: '11px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '3px'
    }}
  >
    <MdExplore size={14}/> {t("feed")}
  </div>

 {isOwner && (
  <div
    onClick={() => setActiveView('reels')}
    style={{
      color: activeView === 'reels' ? '#ff416c' : 'white',
      fontSize: '11px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '3px'
    }}
  >
    <BsFillPlayCircleFill size={13}/> {t("live")}
  </div>
)}






{/* ✅ HISTORY */}
 {isOwner && (
  <div
    onClick={() => setActiveView('history')}
    style={{
      color: activeView === 'history' ? '#ff416c' : 'white',
      fontSize: '11px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '3px'
    }}
  >
    
    <FaHistory size={13}/> {t("history")}
  </div>
)}

  {/* ✅ ADD FINANCE HERE */}
 {isOwner && (
  <div
    onClick={() => setActiveView('finance')}
    style={{
      color: activeView === 'finance' ? '#ff416c' : 'white',
      fontSize: '11px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '3px'
    }}
  >
    <FaWallet size={13}/> {t("finance")}
  </div>
)}

  <img
    src={profilePic}
    alt=""
    style={{
      border: "1px solid #00c853",
      width: 24,
      height: 24,
      borderRadius: "50%",
      marginLeft: '4px'
    }}
  />
</div>
      </div>

     <div className="social-container" style={{ paddingBottom: '60px' }}>


<div
  style={{
    padding: "10px 0",
    background: "#fff",
    borderBottom: "1px solid #eee",
    marginBottom: "10px"
  }}
>
  <h4
    style={{
      marginLeft: "12px",
      marginBottom: "10px",
      fontSize: "11px",
      color: "#18508a",
      textTransform: "uppercase",
      fontWeight: "700"
    }}
  >
    {t("recent")}
  </h4>

<div
  style={{
    display: "flex",
    overflowX: "auto",
    overflowY: "hidden",
    gap: "14px",
    padding: "0 12px 8px 12px",
    scrollBehavior: "smooth",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    whiteSpace: "nowrap",
  }}
  className="recent-passenger-scroll"
>
    {myRides.map((ride, index) => (
      <div
        key={`${ride.id}-${index}`}
        onClick={async () => {

          if (!ride.passengerId) {
            setSelectedRide(ride);
            return;
          }

          try {
            const snap = await get(
              ref(db, `passengers/${ride.passengerId}`)
            );

            if (snap.exists()) {
              const passengerData = snap.val();

              setSelectedRide({
                ...ride,
                passengerProfile: passengerData
              });
            } else {
              setSelectedRide(ride);
            }

          } catch (err) {
            console.error(err);
            setSelectedRide(ride);
          }
        }}
        style={{
          textAlign: "center",
          flexShrink: 0,
          cursor: "pointer",
          transition: "0.25s"
        }}
      >
        <div
          style={{
            width: "62px",
            height: "62px",
            borderRadius: "50%",
            padding: "3px",

            background:
              ride.status === "completed" || ride.tripEnded
                ? "linear-gradient(135deg,#00c853,#69f0ae)"
                : "linear-gradient(135deg,#18508a,#4facfe)",

            boxShadow:
              ride.status === "completed" || ride.tripEnded
                ? "0 4px 14px rgba(0,200,83,0.35)"
                : "0 4px 14px rgba(24,80,138,0.35)"
          }}
        >
          <img
            src={ride.displayPhoto}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #fff"
            }}
          />
        </div>

        <div
          style={{
            marginTop: "6px",
            width: "65px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "10px",
            fontWeight: "700",
            color: "#333"
          }}
        >
          {ride.passengerName?.split(" ")[0]}
        </div>

        <div
          style={{
            fontSize: "8px",
            color: "#888",
            marginTop: "2px"
          }}
        >
          {formatCurrency(
            Number(ride.fare || 0),
            userCountry
          )}
        </div>
      </div>
    ))}

    {myRides.length === 0 && (
      <small
        style={{
          color: "#aaa",
          paddingLeft: "10px",
          fontSize: "10px"
        }}
      >
        {t("no_history")}
      </small>
    )}
  </div>
</div>



 <div className="driver-stats">
 <div
  className="stat-box stat-total"
onClick={() =>
  setRideStatsView((prev) =>
    prev === "total" ? null : "total"
  )
}  
>
    <div className="stat-glow-circle red-glow">
      <h2>{driver?.totalRides || myRides.length || 0}</h2>
    </div>
    <span>{t("total_rides")}</span>
  </div>

<div
  className="stat-box stat-completed"
onClick={() =>
  setRideStatsView((prev) =>
    prev === "completed" ? null : "completed"
  )
}  
>
    <div className="stat-glow-circle green-glow">
      <h2>{driver?.completedRides || completedRidesCount || 0}</h2>
    </div>
    <span>{t("completed")}</span>
  </div>
</div>



{rideStatsView && (
  <div className="public-ride-history-card">
   {myRides
  .filter((ride) => {
    if (rideStatsView === "completed") {
      return ride.status === "completed" || ride.tripEnded === true;
    }

  if (rideStatsView === "total") {
  return true;
}

    return false;
  })



      .slice(0, 5)
      .map((ride) => (
        <div
          key={ride.id}
          style={{
            margin: "0 10px 10px 10px",
            borderRadius: "8px",
border:
  ride.status === "completed" || ride.tripEnded
    ? "2px solid #00c853"
    : "2px solid #ff1744",            
            background: "#f8fbff",
            padding: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
          }}
        >
          <h3 style={{ margin: "0 0 8px 0", color: "#18508a", fontSize: "14px" }}>
            {ride.passengerName || t("passenger")}
          </h3>

          <div style={{ fontSize: "11px", marginBottom: "8px", color: "#555" }}>
            <div>📍 {ride.distanceKm || ""} km</div>
            <div style={{ fontWeight: "bold", color: "#00c853" }}>
              {formatCurrency(Number(ride.fare || 0), userCountry)}
            </div>
          </div>

          <div style={{ fontSize: "11px", color: "#444", marginBottom: "10px" }}>
            <div>
              <b>{t("pickup")}:</b>{" "}
              {ride.pickupAddress || ride.pickup?.address || t("not_logged")}
            </div>
            <div>
              <b>{t("dropoff")}:</b>{" "}
              {ride.dropoffAddress || ride.destinationCoords?.address || t("not_logged")}
            </div>
          </div>

          <div style={{ display: "flex", gap: "8px" }}>
            <button
              onClick={() => window.open(`tel:${ride.passengerPhone || ""}`)}
              style={{
                flex: 1,
                padding: "7px",
                borderRadius: "6px",
                border: "none",
                background: "#007bff",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "11px"
              }}
            >
            {t("call")}
            </button>

            <button
              onClick={() =>
                window.open(
                  `https://wa.me/${ride.passengerPhone?.replace(/\D/g, "") || ""}`
                )
              }
              style={{
                flex: 1,
                padding: "7px",
                borderRadius: "6px",
                border: "none",
                background: "#25D366",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "11px"
              }}
            >
              {t("chat")}
            </button>
          </div>
        </div>
      ))}
  </div>
)}


  {/* ULTRA-COMPACT RIDE DETAIL CARD */}
  {selectedRide && (
    <div
      style={{
        margin: "0 10px 10px 10px",
        borderRadius: '8px',
        border: "1px solid #18508a",
        background: "#f8fbff",
        position: 'relative',
        padding: '10px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}
    >
      <FaTimes
        style={{ position: "absolute", top: 8, right: 8, cursor: "pointer", color: "#888", fontSize: '12px' }}
        onClick={() => setSelectedRide(null)}
      />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
        <img src={selectedRide.displayPhoto} style={{ width: 36, height: 36, borderRadius: '50%', border: '1px solid #ddd' }} alt="" />
        <h3 style={{ margin: 0, color: "#18508a", fontSize: '14px' }}>{selectedRide.passengerName}</h3>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "6px",
          fontSize: "11px",
          marginBottom: '10px',
          background: '#fff',
          padding: '8px',
          borderRadius: '6px',
          border: '1px solid #eee'
        }}
      >
        <span style={{ color: '#555' }}><FaMapMarkerAlt color="#ff416c" size={10} /> {selectedRide.distanceKm} km</span>
        <span style={{ fontWeight: "bold", color: "#00c853" }}>
<FaMoneyBillWave size={10} /> {formatCurrency(Number(selectedRide.fare || 0), userCountry)}          
          </span>
        <span style={{ color: '#555' }}><FaCalendarAlt color="#888" size={10} /> {selectedRide.date}</span>
        <span style={{ color: '#555' }}><FaClock color="#888" size={10} /> {selectedRide.time}</span>
      </div>

      <div
        style={{
          background: "#fff",
          padding: "8px",
          borderRadius: "6px",
          border: "1px solid #eee",
          fontSize: "10px",
          marginBottom: '10px',
          color: '#444'
        }}
      >
        <div style={{ marginBottom: '4px', display: 'flex', gap: '6px', alignItems: 'flex-start' }}>
          <FaMapPin color="green" size={10} style={{ marginTop: '2px' }} />
          <div><b style={{ color: '#222' }}>{t("pickup")}:</b> {selectedRide.pickupAddress || selectedRide.pickup?.address || t("not_logged")}</div>
        </div>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'flex-start' }}>
          <FaMapPin color="red" size={10} style={{ marginTop: '2px' }} />
          <div><b style={{ color: '#222' }}>{t("dropoff")}:</b> {selectedRide.dropoffAddress || selectedRide.destinationCoords?.address || t("not_logged")}</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: "8px" }}>
        <button
          onClick={() => window.open(`tel:${selectedRide.passengerPhone}`)}
          style={{ flex: 1, padding: "6px", borderRadius: "6px", border: "none", background: "#007bff", color: "white", fontWeight: 'bold', fontSize: '11px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}
        >
          <FaPhone size={10} /> {t("call")}
        </button>
        <button
          onClick={() => window.open(`https://wa.me/${selectedRide.passengerPhone?.replace(/\D/g, '')}`)}
          style={{ flex: 1, padding: "6px", borderRadius: "6px", border: "none", background: "#25D366", color: "white", fontWeight: 'bold', fontSize: '11px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}
        >
          <FaWhatsapp size={12} /> {t("chat")}
        </button>
      </div>
    </div>
  )}





{/* HISTORY */}
{activeView === 'history' && isOwner && (
  <div style={{ padding: "0 10px" }}>

    <div
      style={{
        background: "#fff",
        padding: "12px",
        borderRadius: "12px",
        marginBottom: "12px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
      }}
    >
      <h3
        style={{
          margin: "0 0 12px 0",
          fontSize: "14px",
          color: "#18508a",
          display: "flex",
          alignItems: "center",
          gap: "6px"
        }}
      >
        <FaHistory /> {t("ride_history_dashboard")}
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px",
          marginBottom: "12px"
        }}
      >


     <div style={{ background: "#fff", padding: "10px", borderRadius: "10px", border: "1px solid #e5e7eb" }}>
  <small style={{ color: "#64748b", fontWeight: "600" }}>
{t("total_rides")}    
  </small>

  <h3 style={{ margin: "5px 0", color: "#0c55f1", fontWeight: "700" }}>
    {myRides.length}
  </h3>
</div>

<div style={{ background: "#fff", padding: "10px", borderRadius: "10px", border: "1px solid #e5e7eb" }}>
  <small style={{ color: "#64748b", fontWeight: "600" }}>
{t("completed")}    
  </small>

  <h3 style={{ margin: "5px 0", color: "#3dc21c", fontWeight: "700" }}>
    {completedRidesCount}
  </h3>
</div>

<div style={{ background: "#fff", padding: "10px", borderRadius: "10px", border: "1px solid #e5e7eb" }}>
  <small style={{ color: "#64748b", fontWeight: "600" }}>
    {t("weekly_revenue")}
  </small>

  <h3 style={{ margin: "5px 0", color: "#f00e7f", fontWeight: "700" }}>
{formatCurrency(financeWeeklyTotal, userCountry)}    
  </h3>
</div>

<div style={{ background: "#fff", padding: "10px", borderRadius: "10px", border: "1px solid #e5e7eb" }}>
  <small style={{ color: "#64748b", fontWeight: "600" }}>
  {t("total_revenue")}
  </small>

  <h3 style={{ margin: "5px 0", color: "#f00e7f", fontWeight: "700" }}>
{formatCurrency(totalRev, userCountry)}    
  </h3>
</div>



      </div>

      <div
        style={{
          display: "flex",
          gap: "8px",
          marginBottom: "10px"
        }}
      >
        <input
          type="text"
placeholder={t("search_passenger_location_phone")}          
          value={commentInputs.historySearch || ""}
          onChange={(e) =>
            setCommentInputs((prev) => ({
              ...prev,
              historySearch: e.target.value,
            }))
          }
          style={{
            flex: 1,
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            fontSize: "12px",
            outline: "none"
          }}
        />

        <select
          value={commentInputs.historyFilter || "all"}
          onChange={(e) =>
            setCommentInputs((prev) => ({
              ...prev,
              historyFilter: e.target.value,
            }))
          }
          style={{
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            fontSize: "12px",
            background: "#fff"
          }}
        >
          <option value="all">{t("all")}</option>
<option value="completed">{t("completed")}</option>          
          <option value="accepted">{t("accepted")}</option>
        </select>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "8px"
        }}
      >
        <button
          style={{
            padding: "9px",
            borderRadius: "8px",
            border: "none",
            background: "#18508a",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "11px"
          }}
        >
          📄 {t("export")}
        </button>

        <button
          style={{
            padding: "9px",
            borderRadius: "8px",
            border: "none",
            background: "#00c853",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "11px"
          }}
        >
          🧾 {t("receipts")}
        </button>

        <button
          style={{
            padding: "9px",
            borderRadius: "8px",
            border: "none",
            background: "#ff416c",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "11px"
          }}
        >
          📊 {t("no_history")}
        </button>
      </div>
    </div>





    {myRides
      .filter((ride) => {
        const search = (commentInputs.historySearch || "").toLowerCase();

        const matchesSearch =
          !search ||
          ride.passengerName?.toLowerCase().includes(search) ||
          ride.passengerPhone?.toLowerCase().includes(search) ||
          ride.pickupAddress?.toLowerCase().includes(search) ||
          ride.dropoffAddress?.toLowerCase().includes(search);

        const filter = commentInputs.historyFilter || "all";

        const matchesFilter =
          filter === "all" ||
          ride.status === filter ||
          (filter === "completed" && ride.tripEnded === true);

        return matchesSearch && matchesFilter;
      })
      .map((ride) => (
        <div
          key={ride.id}
          style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "12px",
            marginBottom: "12px",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            borderLeft:
              ride.status === "completed" || ride.tripEnded
                ? "4px solid #00c853"
                : "4px solid #0a4ecc"
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "10px"
            }}
          >
            <img
              src={ride.displayPhoto || "/default-avatar.png"}
              alt=""
              style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />

            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#222"
                }}
              >
                {ride.passengerName || t("passenger")}
              </div>

              <div style={{ fontSize: "11px", color: "#777", marginTop: "2px" }}>
                📞 {ride.passengerPhone || t("no_phone")}
              </div>

              <div style={{ fontSize: "10px", color: "#999", marginTop: "3px" }}>
                {ride.date || new Date(ride.timestamp || Date.now()).toLocaleDateString()} • {ride.time || ""}
              </div>
            </div>

            <div style={{ textAlign: "right" }}>
              <div
                style={{
                  fontWeight: "bold",
                  color: "#00c853",
                  fontSize: "14px"
                }}
              >
{formatCurrency(Number(ride.fare || 0), userCountry)}                
              </div>

              <div
                style={{
                  fontSize: "10px",
                  color:
                    ride.status === "completed" || ride.tripEnded
                      ? "#00c853"
                      : "#0a4ecc",
                  fontWeight: "bold"
                }}
              >
{t(ride.status || "accepted")}                
              </div>
            </div>
          </div>

          <div
            style={{
              background: "#f8f9fa",
              padding: "10px",
              borderRadius: "8px",
              marginBottom: "10px",
              fontSize: "11px",
              color: "#444"
            }}
          >
            <div style={{ marginBottom: "6px" }}>
              📍 <b>{t("pickup")}:</b>{" "}

              {ride.pickupAddress ||
                ride.pickup?.address ||
            t("no_pickup_recorded")   }             
            </div>

            <div>
              🛣️ <b>{t("dropoff")}:</b>{" "}
              {ride.dropoffAddress ||
                ride.destinationCoords?.address ||
            t("no_destination_recorded")}               
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "8px"
            }}
          >
            <button
              onClick={() =>
                window.open(`tel:${ride.passengerPhone || ""}`)
              }
              style={{
                padding: "8px",
                borderRadius: "8px",
                border: "none",
                background: "#18508a",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "11px"
              }}
            >
📞 {t("call")}              

            </button>

            <button
              onClick={() =>
                window.open(
                  `https://wa.me/${ride.passengerPhone?.replace(/\D/g, "") || ""}`
                )
              }
              style={{
                padding: "8px",
                borderRadius: "8px",
                border: "none",
                background: "#25D366",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "11px"
              }}
            >
💬 {t("chat")}
            </button>

            <button
              style={{
                padding: "8px",
                borderRadius: "8px",
                border: "none",
                background: "#0a4ecc",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "11px"
              }}
            >
🧾 {t("receipt")}
            </button>
          </div>
        </div>
      ))}

    {myRides.length === 0 && (
      <div
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "12px",
          textAlign: "center",
          color: "#999",
          fontSize: "12px"
        }}
      >
        🚕 {t("no_ride_history")}
      </div>
    )}
  </div>
)}



 {/* FEED */}
{activeView === 'feed' && (
  <div style={{ padding: "0 10px" }}>
    <div
      style={{
        background: '#fff',
        borderRadius: '10px',
        padding: '12px',
        marginBottom: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: '1px solid #eee',
          paddingBottom: '8px',
          marginBottom: '8px'
        }}
      >
        <img
          src={profilePic}
          alt=""
          style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }}
        />

        <input
          type="text"
placeholder={t("whats_happening")}          
          value={postText}
          onChange={(e) => setPostText(e.target.value)}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: '12px',
            background: '#f0f2f5',
            borderRadius: '20px',
            padding: '9px 12px'
          }}
        />
      </div>

      {selectedFile && (
        <div
          style={{
            background: "#f8f9fa",
            padding: "8px",
            borderRadius: "8px",
            marginBottom: "8px",
            fontSize: "11px",
            color: "#555",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
         <span>
  {mediaType === "video"
    ? `🎥 ${t("video_selected")}`
    : `🖼️ ${t("image_selected")}`}: {selectedFile.name}
</span>
          <button
            onClick={() => {
              setSelectedFile(null);
              setMediaType(null);
            }}
            style={{
              border: "none",
              background: "#ff416c",
              color: "#fff",
              borderRadius: "6px",
              padding: "4px 8px",
              cursor: "pointer"
            }}
          >
         {t("remove")}
          </button>
        </div>
      )}

      {showMoods && (
        <div
          style={{
            display: 'flex',
            gap: '6px',
            flexWrap: 'wrap',
            padding: '7px',
            background: '#f0f2f5',
            borderRadius: '8px',
            marginBottom: '8px'
          }}
        >
          {emojis.map((emoji) => (
            <span
              key={emoji}
              onClick={() => {
                setPostText((prev) => prev + emoji);
                setShowMoods(false);
              }}
              style={{ fontSize: '18px', cursor: 'pointer', padding: '3px' }}
            >
              {emoji}
            </span>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: '5px', justifyContent: 'space-between' }}>
        <button
          style={{
            flex: 1,
            padding: '7px',
            fontSize: '10px',
            background: postFilter === 'image' ? '#e0f7fa' : '#f8f9fa',
            color: '#333',
            border: postFilter === 'image' ? '1px solid #00c853' : '1px solid #eee',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
          onClick={() => setPostFilter(postFilter === 'image' ? 'all' : 'image')}
        >
          <FaImage color="#0a4ecc" /> {t("pictures")}
        </button>

        <button
          style={{
            flex: 1,
            padding: '7px',
            fontSize: '10px',
            background: postFilter === 'video' ? '#e0f7fa' : '#f8f9fa',
            color: '#333',
            border: postFilter === 'video' ? '1px solid #00c853' : '1px solid #eee',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
          onClick={() => setPostFilter(postFilter === 'video' ? 'all' : 'video')}
        >
          <FaVideo color="#2ecc71" /> {t("videos")}
        </button>

        <button
          style={{
            flex: 1,
            padding: '7px',
            fontSize: '10px',
            background: '#f8f9fa',
            color: '#333',
            border: '1px solid #eee',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
          onClick={() => setShowMoods(!showMoods)}
        >
          <FaSmile color="#f39c12" />{t("mood")}
        </button>

        <button
          style={{
            flex: 1,
            padding: '7px',
            fontSize: '11px',
            background: '#ff416c',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
          onClick={handleCreatePost}
          disabled={uploading}
        >
{uploading ? t("posting") : t("post")}          
        </button>
      </div>
</div>


    {posts
      .filter((p) => postFilter === 'all' || p.mediaType === postFilter)
      .map((post) => {
        const likeCount = post.likes ? Object.keys(post.likes).length : 0;
        const commentCount = post.comments ? Object.keys(post.comments).length : 0;
        const alreadyLiked = post.likes && currentUser?.uid && post.likes[currentUser.uid];

        return (
          <div
            key={post.id}
            style={{
              background: '#fff',
              borderRadius: '10px',
              padding: '12px',
              marginBottom: '12px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <img
src={post.authorPhoto || post.userPhoto || "/default-avatar.png"}                
                alt=""
                style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
              />

              <div style={{ flex: 1 }}>
                <div
  style={{
    fontWeight: 'bold',
    fontSize: '12px',
color:
post.authorId === viewedUid || post.authorRole === "driver"  
    ? "#00c853"
    : "#38bdf8"    
  }}
>
{post.authorName || post.userName} {post.authorRole === "driver"? t("driver_icon") : t("user_icon")}  

</div>
                <div style={{ fontSize: '10px', color: '#888' }}>
{timeAgo(post.timestamp)} • {t("public")}                  
                </div>
              </div>

              <button
                style={{
                  border: "none",
                  background: "#f0f2f5",
                  borderRadius: "20px",
                  padding: "5px 8px",
                  cursor: "pointer",
                  fontSize: "11px"
                }}
              >
                ⋯
              </button>
            </div>

            {post.text && (
              <div style={{ fontSize: '13px', color: '#333', marginBottom: '8px', lineHeight: '1.45' }}>
                {post.text}
              </div>
            )}

            {post.mediaUrl && post.mediaType === 'image' && (
              <img
                src={post.mediaUrl}
                alt=""
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  maxHeight: '260px',
                  objectFit: 'cover',
                  marginBottom: "8px"
                }}
              />
            )}

            {post.mediaUrl && post.mediaType === 'video' && (
              <video
                src={post.mediaUrl}
                controls
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  maxHeight: '260px',
                  background: '#000',
                  marginBottom: "8px"
                }}
              />
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "11px",
                color: "#777",
                borderBottom: "1px solid #eee",
                paddingBottom: "7px",
                marginBottom: "7px"
              }}
            >
              <span>❤️ {likeCount} {t("likes")}</span>
<span>{commentCount} {t("comments")} • ↗ {t("shares")}</span>              
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "5px",
                borderBottom: "1px solid #eee",
                paddingBottom: "8px",
                marginBottom: "8px"
              }}
            >
              <button
                onClick={async () => {
                  if (!currentUser) return;
                  const likeRef = ref(db, `social_posts/${post.id}/likes/${currentUser.uid}`);
                  const snap = await get(likeRef);

                  if (snap.exists()) {
                    await remove(likeRef);
                  } else {
                    await set(likeRef, {
                      userId: currentUser.uid,
                      userName: currentUser.displayName || localStorage.getItem("name") || "User",
userPhoto: currentUser.photoURL || localStorage.getItem("photoURL") || "/default-avatar.png",
role: localStorage.getItem("role") || "driver",
                      likedAt: Date.now()
                    });
                  }
                }}
                style={{
                  padding: "7px",
                  border: "none",
                  borderRadius: "6px",
                  background: alreadyLiked ? "#ffe6ec" : "#f8f9fa",
                  color: alreadyLiked ? "#ff416c" : "#444",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "11px"
                }}
              >
❤️ {t("like")}
              </button>

              <button
                style={{
                  padding: "7px",
                  border: "none",
                  borderRadius: "6px",
                  background: "#f8f9fa",
                  color: "#444",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "11px"
                }}
              >
                💬 {t("comment")}
              </button>

              <button
                onClick={() => {
                  if (navigator.share) {
                    navigator.share({
                      title: "KinaHub Post",
                      text: post.text || "View this KinaHub post",
                      url: window.location.href
                    });
                  } else {
                    navigator.clipboard.writeText(window.location.href);
                    alert(t("post_link_copied"));
                  }
                }}
                style={{
                  padding: "7px",
                  border: "none",
                  borderRadius: "6px",
                  background: "#f8f9fa",
                  color: "#444",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "11px"
                }}
              >
                ↗ {t("share")}
              </button>
            </div>

            <div style={{ marginTop: "8px" }}>
              {post.comments &&
                Object.entries(post.comments)
                  .sort((a, b) => (a[1].timestamp || 0) - (b[1].timestamp || 0))
                  .map(([commentId, comment]) => (
                    <div
                      key={commentId}
                      style={{
                        marginBottom: "6px",
                        fontSize: "12px",
                        background: "#f7f7f7",
                        padding: "8px",
                        borderRadius: "8px"
                      }}
                    >
                      <div style={{ display: "flex", gap: "6px", alignItems: "center", marginBottom: "3px" }}>
                        <img
                          src={comment.userPhoto || "/default-avatar.png"}
                          alt=""
                          style={{ width: 22, height: 22, borderRadius: "50%", objectFit: "cover" }}
                        />
                        <b>{comment.userName}</b>
                        <small style={{ color: "#999" }}>{timeAgo(comment.timestamp)}</small>
                      </div>

                      <div style={{ marginLeft: "28px", color: "#333" }}>
                        {comment.text}
                      </div>
                    </div>
                  ))}

              <div style={{ display: "flex", gap: "6px", marginTop: "8px" }}>
                <input
                  type="text"
placeholder={t("write_comment")}                  
                  value={commentInputs[post.id] || ""}
                  onChange={(e) =>
                    setCommentInputs((prev) => ({
                      ...prev,
                      [post.id]: e.target.value,
                    }))
                  }
                  style={{
                    flex: 1,
                    padding: "9px",
                    border: "1px solid #ddd",
                    borderRadius: "20px",
                    fontSize: "12px",
                    outline: "none"
                  }}
                />

                <button
                  onClick={() => handleAddComment(post.id)}
                  style={{
                    padding: "8px 13px",
                    border: "none",
                    borderRadius: "20px",
                    background: "#18508a",
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "bold"
                  }}
                >
                  {t("send")}
                </button>
              </div>
            </div>
          </div>
        );
      })}
  </div>
)}




 {/* PRIVATE WARNING */}
{(activeView === 'finance' || activeView === 'history') && !isOwner && (
  <div style={{ padding: "25px", textAlign: "center", color: "#999", fontSize: "13px" }}>
🔒 {t("private_account_section")}
  </div>
)}




{/* FINANCE - OWNER ONLY */}
{activeView === 'finance' && isOwner && (
  <div style={{ padding: "0 10px" }}>

    <div
      style={{
        background: "linear-gradient(135deg, #18508a, #0a4ecc)",
        borderRadius: "14px",
        padding: "16px",
        marginBottom: "12px",
        color: "#fff",
        boxShadow: "0 4px 14px rgba(0,0,0,0.2)"
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          gap: "6px"
        }}
      >
        <FaWallet /> {t("kinatrip_finance_wallet")}
      </h3>

      <div style={{ fontSize: "30px", fontWeight: "bold", marginTop: "10px" }}>
{formatCurrency(totalRev, userCountry)}        
      </div>

      <div style={{ fontSize: "11px", opacity: 0.85 }}>
{t("lifetime_gross_earnings")}        
      </div>

      <div
        style={{
          marginTop: "12px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px"
        }}
      >
        <div
          style={{
            background: "rgba(255,255,255,0.15)",
            padding: "8px",
            borderRadius: "10px"
          }}
        >
          <small>{t("available_balance")}</small>
          <div style={{ fontWeight: "bold", fontSize: "15px" }}>
{formatCurrency(totalRev, userCountry)}            
          </div>
        </div>

       
      </div>
    </div>

     <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px",
    marginBottom: "12px"
  }}
>

  <div
    style={{
background: "#fff",      
      padding: "12px",
      borderRadius: "12px",
border: "1px solid #e5e7eb"      
    }}
  >
    <small style={{ color: "#64748b", fontWeight: "600" }}>
      {t("today")}
    </small>

    <h3
      style={{
        margin: "5px 0",
        color: "#0c55f1",
        fontWeight: "700"
      }}
    >
{formatCurrency(dailyRev, userCountry)}      
    </h3>
  </div>

  <div
    style={{
      background:"#fff",
      padding: "12px",
      borderRadius: "12px",
border: "1px solid #e5e7eb"      
    }}
  >
    <small style={{ color: "#64748b", fontWeight: "600" }}>
   {t("this_week")}
    </small>

    <h3
      style={{
        margin: "5px 0",
        color: "#3dc21c",
        fontWeight: "700"
      }}
    >
{formatCurrency(financeWeeklyTotal, userCountry)}      
    </h3>
  </div>

  <div
    style={{
background: "#fff",      
      padding: "12px",
      borderRadius: "12px",
border: "1px solid #e5e7eb"      
    }}
  >
    <small style={{ color: "#64748b", fontWeight: "600" }}>
      {t("this_month")}
    </small>

    <h3
      style={{
        margin: "5px 0",
        color: "#f00e7f",
        fontWeight: "700"
      }}
    >
{formatCurrency(financeMonthlyTotal, userCountry)}      
    </h3>
  </div>

  <div
    style={{
background: "#fff",      
      padding: "12px",
      borderRadius: "12px",
border: "1px solid #e5e7eb"      
    }}
  >
    <small style={{ color: "#64748b", fontWeight: "600" }}>
      {t("this_year")}
    </small>

    <h3
      style={{
        margin: "5px 0",
        color: "#f00e7f",
        fontWeight: "700"
      }}
    >
{formatCurrency(financeYearlyTotal, userCountry)}

    </h3>
  </div>

</div>

    <div
      style={{
        background:"white",
        borderRadius: "12px",
        padding: "12px",
        marginBottom: "12px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
      }}
    >
      <h3 style={{ margin: "0 0 10px 0", fontSize: "13px", color: "#18508a" }}>
       {t("finance_actions")}
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px"
        }}
      >
       <button
  onClick={() => setShowTransactions((prev) => !prev)}
  style={{
    padding: "11px",
    borderRadius: "10px",
    border: "none",
    background: "#00c853",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "12px",
    cursor: "pointer"
  }}
>
  📋 {t("transaction_records")}
</button>

        <button
          onClick={() => window.print()}
          style={{
            padding: "11px",
            borderRadius: "10px",
            border: "none",
             background: "#0a4ecc",                   
            color: "#fff",
            fontWeight: "bold",
            fontSize: "12px",
            cursor: "pointer"
          }}
        >
          📄 {t("export_report")}
        </button>

        <button
          onClick={() => alert(t("select_transaction_receipt"))}

          style={{
            padding: "11px",
            borderRadius: "10px",
            border: "none",
            background: "#0a4ecc",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "12px",
            cursor: "pointer"
          }}
        >
          🧾 {t("receipts")}
        </button>

        <button
          onClick={() => alert(
  `Tax Summary\nGross: ${formatCurrency(totalRev, userCountry)}\nEstimated taxable record: ${formatCurrency(totalRev, userCountry)}`
)}

          style={{
            padding: "11px",
            borderRadius: "10px",
            border: "none",
            background: "#333",

            color: "#fff",
            fontWeight: "bold",
            fontSize: "12px",
            cursor: "pointer"
          }}
        >
          📊 {t("tax_summary")}
        </button>
      </div>
    </div>

 <div
  style={{
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",

    gap: "10px",
    height: "220px",

    marginTop: "20px",

    overflowX: "auto",

    padding: "18px",
    paddingBottom: "12px",

    borderRadius: "22px",

    background:
      "linear-gradient(180deg,#111827,#1e293b)",

    boxShadow:
      "0 10px 25px rgba(0,0,0,0.25)"
  }}
>

  {weeklyFinance.map((item, index) => {

    const barHeight =
      historyBarsMax > 0
        ? (item.total / historyBarsMax) * 160
        : 10;

    return (
      <div
        key={item.day}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "55px"
        }}
      >
        <div
          style={{
            fontSize: "10px",
            fontWeight: "bold",
            color: item.total > 0 ? "#18508a" : "#999",
            marginBottom: "8px",
            textAlign: "center"
          }}
        >
          {formatCurrency(item.total, userCountry)}
        </div>

        <div
          style={{
            width: "38px",
            height: `${Math.max(barHeight, 8)}px`,
            borderRadius: "14px 14px 6px 6px",
            background:
              item.total > 0
                ? "linear-gradient(180deg,#4facfe,#18508a)"
                : "#dfe6ee",
            boxShadow:
              item.total > 0
                ? "0 6px 18px rgba(24,80,138,0.25)"
                : "none",
            transition: "0.3s"
          }}
        />

        <div
          style={{
            marginTop: "10px",
            fontSize: "10px",
            fontWeight: "600",
color: "rgba(255,255,255,0.85)",

            textAlign: "center"
          }}
        >
          {item.day}
        </div>
      </div>
    );
  })}
</div>

  {showTransactions && (
<div
  style={{
    background: "#fff",
    borderRadius: "12px",
    padding: "12px",
    marginBottom: "12px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
  }}
>
  <h3 style={{ margin: "0 0 10px 0", fontSize: "13px", color: "#18508a" }}>
{t("transaction_records")}    
  </h3>

      <input
        type="text"
placeholder={t("search_transaction")}        
        value={commentInputs.financeSearch || ""}
        onChange={(e) =>
          setCommentInputs((prev) => ({
            ...prev,
            financeSearch: e.target.value,
          }))
        }
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ddd",
          marginBottom: "10px",
          fontSize: "12px",
          outline: "none"
        }}
      />

      {myRides
        .filter((ride) => {
          const search = (commentInputs.financeSearch || "").toLowerCase();

          return (
            !search ||
            ride.passengerName?.toLowerCase().includes(search) ||
            ride.passengerPhone?.toLowerCase().includes(search) ||
            ride.status?.toLowerCase().includes(search)
          );
        })
        .slice(0, 20)
        .map((ride) => {
          const gross = Number(ride.fare || 0);
          const platformFee = gross * 0.1;
          const net = gross - platformFee;

          return (
            <div
              key={ride.id}
              style={{
                border: "1px solid #eee",
                borderRadius: "10px",
                padding: "10px",
                marginBottom: "8px",
                background: "#fafafa"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "8px",
                  marginBottom: "6px"
                }}
              >
                <div>
                  <div style={{ fontSize: "12px", fontWeight: "bold", color: "#222" }}>
                    {ride.passengerName || t("passenger_ride")}
                  </div>

                  <div style={{ fontSize: "10px", color: "#888" }}>
                    {ride.date || new Date(ride.timestamp || Date.now()).toLocaleDateString()} • {ride.time || ""}
                  </div>
                </div>

                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: "13px", fontWeight: "bold", color: "#00c853" }}>
+{formatCurrency(gross, userCountry)}                    
                  </div>

                  <div style={{ fontSize: "9px", color: "#888" }}>
{t(ride.status || "completed")}                    
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "6px",
                  fontSize: "10px",
                  color: "#555",
                  background: "#fff",
                  padding: "7px",
                  borderRadius: "8px",
                  marginBottom: "8px"
                }}
              >
                <div>
                  <b>{t("gross")}</b>
                  <br />
{formatCurrency(gross, userCountry)}                  
                </div>

                <div>
                  <b>{t("platform_fee")}</b>
                  <br />
{formatCurrency(platformFee, userCountry)}                  
                </div>

                <div>
                  <b>{t("net")}</b>
                  <br />
{formatCurrency(net, userCountry)}                  
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "8px"
                }}
              >
               
              </div>
            </div>
          );
        })}

           {myRides.length === 0 && (
        <p style={{ textAlign: "center", color: "#aaa", fontSize: "12px" }}>
          {t("no_finance_transactions")}
        </p>
      )}
        </div>
  )}

  </div>
)}



{/* LIVE */}
{activeView === 'reels' && (
  <div style={{ padding: "0 10px" }}>
    <div
      style={{
        background: "linear-gradient(135deg, #111, #18508a)",
        padding: "14px",
        borderRadius: "12px",
        marginBottom: "12px",
        color: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.18)"
      }}
    >
      <h3 style={{ fontSize: "14px", margin: "0 0 10px 0" }}>
        🔴 {t("kinahub_live_center")}
      </h3>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
       <button
  onClick={() => {
    alert("Live streaming coming soon");
  }}
  style={{
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "bold"
  }}
>
  🎥 {t("go_live")}
</button>


        <button
          onClick={() => fabInputRef.current.click()}
          style={{ padding: "10px", borderRadius: "8px", border: "none", fontWeight: "bold" }}
        >
          📹 {t("upload_reel")}
        </button>




   <button
  onClick={async () => {
    try {

      const newStatus = !isOnline;

      if (newStatus) {

        await set(
          ref(db, `onlineDrivers/${viewedUid}`),
          {
            uid: viewedUid,
            online: true,
            updatedAt: Date.now(),

            driverName: userName,

            driverPhoto: profilePic,
          }
        );

      } else {

        await remove(
          ref(db, `onlineDrivers/${viewedUid}`)
        );

      }

      setIsOnline(newStatus);

      alert(
        newStatus
          ? "You are now online"
          : "You are now offline"
      );

    } catch (err) {

      console.error(err);

      alert("Failed to update online status");

    }
  }}

  style={{
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "bold",
    background: isOnline ? "#ff416c" : "#00c853",
    color: "#fff"
  }}
>
  {isOnline ? "🔴 Go Offline" : "🟢 Go Online"}
</button>



       <button
  onClick={async () => {

    try {

      await set(
        push(ref(db, "safety_alerts")),
        {
          uid: viewedUid,
          driverName: userName,
          timestamp: Date.now(),
          status: "emergency",
          live: true
        }
      );

      alert("Emergency alert sent");

    } catch (err) {
      console.error(err);
    }
  }}
  style={{
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "bold",
    background: "#ff1744",
    color: "#fff"
  }}
>
  🚨 {t("safety_alert")}
</button>
      </div>
    </div>

    <div
      style={{
        background: "#fff",
        borderRadius: "10px",
        padding: "10px",
        marginBottom: "12px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: "6px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
      }}
    >
      <div>
        <b style={{ color: "#ff416c" }}>{reels.length}</b>
        <div style={{ fontSize: "10px", color: "#888" }}>{t("videos")}</div>
      </div>

      <div>
        <b style={{ color: "#00c853" }}>{isOwner ? (t("owner")
) : t("viewer")}</b>
        <div style={{ fontSize: "10px", color: "#888" }}>{t("access")}</div>
      </div>

      <div>
        <b style={{ color: "#18508a" }}>{t("public")}</b>
        <div style={{ fontSize: "10px", color: "#888" }}>{t("visibility")}</div>
      </div>
    </div>

    {reels.length === 0 && (
      <div
        style={{
          background: "#fff",
          padding: "25px",
          borderRadius: "12px",
          textAlign: "center",
          color: "#999",
          fontSize: "12px"
        }}
      >
        <div style={{ fontSize: "32px", marginBottom: "8px" }}>🎬</div>
        {t("no_live_videos")}
      </div>
    )}

    {reels.map((reel) => {
      const reelLikeCount = reel.likes ? Object.keys(reel.likes).length : 0;
      const reelCommentCount = reel.comments ? Object.keys(reel.comments).length : 0;
      const alreadyLikedReel = reel.likes && currentUser?.uid && reel.likes[currentUser.uid];

      return (
        <div
          key={reel.id}
          style={{
            width: "100%",
            height: "58vh",
            background: "black",
            borderRadius: "14px",
            overflow: "hidden",
            position: "relative",
            marginBottom: "14px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.22)"
          }}
        >
          <video
            src={reel.videoUrl || reel.mediaUrl}
            controls
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />

          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              background: "#ff1744",
              color: "#fff",
              padding: "4px 9px",
              borderRadius: "20px",
              fontSize: "10px",
              fontWeight: "bold"
            }}
          >
           {t("live")}
          </div>

          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "rgba(0,0,0,0.55)",
              color: "#fff",
              padding: "4px 9px",
              borderRadius: "20px",
              fontSize: "10px",
              fontWeight: "bold"
            }}
          >
            👁 {reel.views || 0}
          </div>

          <div
            style={{
              position: "absolute",
              right: "10px",
              bottom: "100px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
              color: "#fff"
            }}
          >
            <button
              onClick={async () => {
                if (!currentUser) return;
                const likeRef = ref(db, `social_reels/${reel.id}/likes/${currentUser.uid}`);
                const snap = await get(likeRef);

                if (snap.exists()) {
                  await remove(likeRef);
                } else {
                  await set(likeRef, {
                    userId: currentUser.uid,
                    userName: currentUser.displayName || localStorage.getItem("name") || "User",
userPhoto: currentUser.photoURL || localStorage.getItem("photoURL") || "/default-avatar.png",
role: localStorage.getItem("role") || "driver",
                    likedAt: Date.now()
                  });
                }
              }}
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                border: "none",
                background: alreadyLikedReel ? "#ff416c" : "rgba(255,255,255,0.2)",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px"
              }}
            >
              ❤️
            </button>
            <small>{reelLikeCount}</small>

            <button
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                border: "none",
                background: "rgba(255,255,255,0.2)",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px"
              }}
            >
              💬
            </button>
            <small>{reelCommentCount}</small>

            <button
              onClick={() => {
                if (navigator.share) {
                  navigator.share({
                    title: "KinaHub Live",
                    text: reel.caption || "Watch this KinaHub live/reel",
                    url: window.location.href
                  });
                } else {
                  navigator.clipboard.writeText(window.location.href);
                  alert("Live link copied");
                }
              }}
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                border: "none",
                background: "rgba(255,255,255,0.2)",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px"
              }}
            >
              ↗
            </button>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "45px 12px 14px 12px",
              background: "linear-gradient(transparent, rgba(0,0,0,0.9))",
              color: "white"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
              <img
                src={reel.userPhoto || profilePic || "/default-avatar.png"}
                alt=""
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "1px solid #fff"
                }}
              />

              <div>
                <h3 style={{ margin: 0, fontSize: "13px" }}>
                  {reel.userName || userName} {reel.userRole === "driver" && "🚕"}
                </h3>
                <p style={{ margin: "2px 0 0 0", fontSize: "10px", opacity: 0.8 }}>
                  Live • {timeAgo(reel.timestamp)}
                </p>
              </div>
            </div>

            {reel.caption && (
              <div style={{ fontSize: "12px", lineHeight: "1.4", marginBottom: "8px" }}>
                {reel.caption}
              </div>
            )}

            <div style={{ display: "flex", gap: "8px", marginBottom: "8px", fontSize: "11px" }}>
              <span>❤️ {reelLikeCount}</span>
              <span>💬 {reelCommentCount}</span>
              <span>👁 {reel.views || 0}</span>
              <span>🌐 {t("public")}</span>
            </div>

            <div
              style={{
                display: "flex",
                gap: "6px",
                background: "rgba(255,255,255,0.12)",
                padding: "6px",
                borderRadius: "20px"
              }}
            >
              <input
                type="text"
                placeholder="Comment on live..."
                value={commentInputs[`reel_${reel.id}`] || ""}
                onChange={(e) =>
                  setCommentInputs((prev) => ({
                    ...prev,
                    [`reel_${reel.id}`]: e.target.value,
                  }))
                }
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  color: "#fff",
                  fontSize: "12px",
                  padding: "6px"
                }}
              />

              <button
                onClick={async () => {
                  if (!currentUser) return;
                  const text = (commentInputs[`reel_${reel.id}`] || "").trim();
                  if (!text) return;

                  const commentRef = push(ref(db, `social_reels/${reel.id}/comments`));
                  await set(commentRef, {
                    userId: currentUser.uid,
userName: currentUser.displayName || localStorage.getItem("name") || "User",                    
userPhoto: currentUser.photoURL || localStorage.getItem("photoURL") || "/default-avatar.png",                    
                    text,
                    timestamp: Date.now(),
role: localStorage.getItem("role") || "driver"                    
                  });

                  setCommentInputs((prev) => ({
                    ...prev,
                    [`reel_${reel.id}`]: "",
                  }));
                }}
                style={{
                  border: "none",
                  background: "#ff416c",
                  color: "#fff",
                  borderRadius: "16px",
                  padding: "6px 10px",
                  fontSize: "11px",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      );
    })}
  </div>
)}

{/* ULTRA-COMPACT BOTTOM NAV */}
<div className="social-bottom-nav" style={{ height: '45px', padding: '0 15px', borderTop: '1px solid #ddd' }}>
  <FaHome
    size={18}
    style={{ color: activeView === 'feed' ? '#ff416c' : '#18508a', cursor: 'pointer' }}
    onClick={() => { setActiveView('feed'); setPostFilter('all'); }}
  />

  <BsFillPlayCircleFill
    size={18}
    style={{ color: activeView === 'reels' ? '#ff416c' : '#18508a', cursor: 'pointer' }}
    onClick={() => setActiveView('reels')}
  />

  <div
    style={{
      width: '38px',
      height: '38px',
      borderRadius: '50%',
      background: '#ff416c',
      color: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '20px',
      cursor: 'pointer',
      transform: 'translateY(-10px)',
      boxShadow: '0 2px 5px rgba(255,65,108,0.4)'
    }}
    onClick={() => fabInputRef.current.click()}
  >
    +
  </div>

  <IoMdChatbubbles size={20} color="#18508a" style={{ cursor: 'pointer' }} />

  <FaUser
    size={18}
    color="#18508a"
    style={{ cursor: 'pointer' }}
    onClick={onClose}
  />
</div>

</div>

</div>
  );
};

export default DriverProfileOverlay;
